var map;
var autocomplete;
var polygon;
var mapUpdater;
var lastMapData;
var counterAddress;

$(document).on(
    "click mouseover",
    "div.textarea-add-new-address .clickAddress",
    function () {
        if ($(this).prop("readonly")) {
            $(this)
                .attr("data-toggle", "tooltip")
                .attr("data-html", "true")
                .attr(
                    "title",
                    "<b>Please! Type address in search address box or drag map.</b>"
                );
            $(this).tooltip("show");
        } else {
            $(this)
                .removeAttr("data-toggle")
                .removeAttr("data-html")
                .removeAttr("title");
            $(this).tooltip("hide");
        }
    }
);

$(document).ready(function () {
    checkAddressCount();
});

const checkAddressCount = () => {
    counterAddress = $("a.address").length;
    if (!counterAddress) {
        $(".default-address-button").hide();
    }
};

const componentForm = {
    street_number: "short_name",
    route: "long_name",
    locality: "long_name",
    postal_town: "long_name",
    administrative_area_level_1: "short_name",
    postal_code: "short_name",
    country: "long_name",
};

window.googleMaps = function () {
    var triangleCoordsGoogle = new Array();

    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < triangleCoords.length; i++) {
        var myLatLng = new google.maps.LatLng(
            triangleCoords[i][0],
            triangleCoords[i][1]
        );
        triangleCoordsGoogle.push(myLatLng);
        bounds.extend(myLatLng);
    }

    polygon = new google.maps.Polygon({
        path: triangleCoordsGoogle,
    });

    var mapDiv = document.getElementById("map");
    var input = document.getElementById("pac-input");

    if (!map) {
        map = new google.maps.Map(mapDiv, {
            center: restaurantlatlng,
            zoom: 17,
            disableDefaultUI: true,
            mapTypeControl: true,
            mapTypeControlOptions: {
                style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
            },
            zoomControl: true,
            scaleControl: true,
            rotateControl: true,
        });
        const centerControlDiv = document.createElement("div");
        CenterControl(centerControlDiv, map);
        map.controls[google.maps.ControlPosition.TOP_RIGHT].push(
            centerControlDiv
        );
    }

    $("<div/>")
        .addClass("centerMarkerText")
        .appendTo(map.getDiv())
        .html("Please! <br> Type address in search address box or drag map.");
    $("<div/>").addClass("centerMarker").appendTo(map.getDiv());

    function googleEvent(event) {
        if (event) {
            var latLng = event.latLng.toJSON();
        } else {
            var latLng = map.getCenter().toJSON();
        }
        blockEl(".centerMarkerText");
        clearTimeout(mapUpdater);
        mapUpdater = setTimeout(function () {
            getAddressMarked(latLng);
        }, 500);
    }

    google.maps.event.addListener(map, "dragstart", function () {
        blockEl(".centerMarkerText");
    });
    //google.maps.event.addListenerOnce(map, "idle", googleEvent);
    google.maps.event.addListener(map, "dragend", googleEvent);
    google.maps.event.addListener(map, "click", googleEvent);

    if (!autocomplete) {
        autocomplete = new google.maps.places.Autocomplete(input, {
            strictBounds: strictBounds,
            bounds: bounds,
        });
    }

    autocomplete.addListener("place_changed", async function () {
        blockEl(".centerMarkerText");
        clearTimeout(mapUpdater);
        mapUpdater = setTimeout(function () {
            var place = autocomplete.getPlace();
            if (!place.geometry || !inside(place.geometry.location.toJSON())) {
                if (!place.geometry) {
                    Swal.fire(
                        "Oops...",
                        "No details available for input: '" + place.name + "'",
                        "error"
                    );
                } else {
                    //console.log(place);
                    Swal.fire(
                        "Oops...",
                        "We do not provide service at the address you have chosen.",
                        "error"
                    );
                }
                marked(lastMapData);
                clearAddressData();
                return;
            } else {
                place.geometry.location = place.geometry.location.toJSON();
                place.formatted_address = $("#pac-input").val();
                getAddressMarkedHelp(place);
            }
        }, 500);
    });
};

window.getAddressMarked = function (latlng) {
    blockEl(".centerMarkerText");
    if (inside(latlng)) {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode(
            {
                location: latlng,
            },
            (results, status) => {
                if (status === "OK") {
                    if (results[0]) {
                        var result = results[0];
                        result.geometry.location = latlng;
                        getAddressMarkedHelp(result);
                    }
                }
            }
        );
    } else {
        Swal.fire(
            "Oops...",
            "We do not provide service at the address you have chosen.",
            "error"
        );
        clearAddressData();
        marked(lastMapData);
        unBlockEl(".centerMarkerText");
    }
};

window.getAddressMarkedHelp = function (data) {
    clearAddressData();
    fillInAddress(data.address_components);
    marked(data);
};

window.marked = function (data) {
    var centerMarkerText = $(".centerMarkerText");
    var mapConfirm = $("#mapConfirm");
    //console.log(data);
    var string =
        data.formatted_address.length > 100
            ? data.formatted_address.substr(0, 100) + "..."
            : data.formatted_address;
    centerMarkerText.html(string);

    $("input[name=latLng]").val(
        data.geometry.location.lat + "," + data.geometry.location.lng
    );
    $("input[name=address_id]").val(data.place_id);

    centerMarkerText.css("border-color", "#17c671");
    mapConfirm.prop("disabled", false);
    map.setCenter(data.geometry.location);
    unBlockEl(".centerMarkerText");
    lastMapData = data;
};

$(document).on("click", "#clearSearchAddressInput", function () {
    $("#pac-input").val("");
});

window.initiate_geolocation = function () {
    if (navigator.geolocation) {
        blockEl(".centerMarkerText");
        navigator.geolocation.getCurrentPosition(function (position) {
            var latLng = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
            };
            getAddressMarked(latLng);
        }, handle_errors);
    } else {
        Swal.fire(
            "Oops...",
            "Your device does not support the positioning feature.",
            "error"
        );
    }
};

window.handle_errors = function (error) {
    switch (error.code) {
        case error.PERMISSION_DENIED:
            Swal.fire(
                "Oops...",
                "The transaction could not be completed because the location information is not shared.",
                "error"
            );
            break;
        case error.POSITION_UNAVAILABLE:
            Swal.fire(
                "Oops...",
                "Your current location could not be determined.",
                "error"
            );
            break;
        case error.TIMEOUT:
            Swal.fire(
                "Oops...",
                "Time-out occurred during location detection.",
                "error"
            );
            break;
        default:
            Swal.fire("Oops...", "Unknown Error", "error");
            break;
    }
};

window.inside = function (location) {
    if (strictBounds) {
        return google.maps.geometry.poly.containsLocation(
            new google.maps.LatLng(location.lat, location.lng),
            polygon
        );
    }
    return true;
};

window.CenterControl = function (controlDiv, map) {
    // Set CSS for the control border.
    const controlUI = document.createElement("div");
    controlUI.style.backgroundColor = "#fff";
    controlUI.style.border = "2px solid #fff";
    controlUI.style.borderRadius = "3px";
    controlUI.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)";
    controlUI.style.cursor = "pointer";
    controlUI.style.marginRight = "10px";
    controlUI.style.marginTop = "10px";
    controlUI.style.width = "40px";
    controlUI.style.height = "40px";
    controlUI.style.textAlign = "center";
    controlUI.title = "Click to recenter the map";
    controlDiv.appendChild(controlUI);
    // Set CSS for the control interior.
    const controlText = document.createElement("div");
    controlText.style.color = "rgb(25,25,25)";
    controlText.style.fontFamily = "Roboto,Arial,sans-serif";
    controlText.style.fontSize = "16px";
    controlText.style.lineHeight = "38px";
    controlText.style.paddingLeft = "5px";
    controlText.style.paddingRight = "5px";
    controlText.innerHTML =
        '<i class="fas fa-map-marker-alt blink_me" style="color:#007bff"></i>';
    controlUI.appendChild(controlText);
    // Setup the click event listeners: simply set the map to Chicago.
    controlUI.addEventListener("click", () => {
        initiate_geolocation();
    });
};

window.fillInAddress = function (address_components) {
    clearAddressComponents();
    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    for (const component of address_components) {
        const addressType = component.types[0];
        if (componentForm[addressType]) {
            const val = component[componentForm[addressType]];
            if (addressType == "postal_town" || addressType == "locality") {
                document.getElementById("locality").value = val;
            } else {
                document.getElementById(addressType).value = val;
            }
        }
    }

    for (const component in componentForm) {
        if (document.getElementById(component)) {
            if (document.getElementById(component).value == "") {
                document.getElementById(component).removeAttribute("readonly");
            } else {
                document.getElementById(component).readOnly = true;
            }
        }
    }

    document.getElementById("street_number").removeAttribute("readonly");
};

$(document).on("click", "#mapConfirm", function () {
    var alert = false;
    for (const component in componentForm) {
        if (document.getElementById(component)) {
            if (document.getElementById(component).value.trim() == "") {
                alert = true;
            }
        }
    }

    if (alert != "") {
        $(".default-address-button").hide();
        return Swal.fire("Oops...", "Please fill the starred fields.", "error");
    }

    var dataAddressTitle = $("input[name=address_title]").val();
    $(".textarea-add-new-address").find("button").prop("disabled", true);

    var address_components = {};
    $("#selectMapDiv input, #selectMapDiv textarea").each(function (i, obj) {
        address_components[obj.name] = $(obj).val();
    });
    delete address_components.address_directions;
    delete address_components.latLng;
    delete address_components.address_id;
    delete address_components.pacInput;

    $.ajax({
        url: window.location.origin + "/address/add",
        type: "post",
        data: {
            address_components: address_components,
            address_id: $("input[name=address_id]").val(),
            latLng: $("input[name=latLng]").val(),
            address_directions: $("textarea[name=address_directions]").val(),
            v2: true,
        },
        dataType: "json",
        success: function (data) {
            $(".default-address-button").show();
            addressesList(data);
            $("button.pay-modal-next").html("NEXT->").prop("disabled", false);
        },
        error: function (e) {
            $("button.btn.btn-warning.btn-block.my-all-addresses").prop(
                "disabled",
                false
            );
            $("button#mapConfirm").prop("disabled", false);
        },
    });
});

$(document).on("click", "#pills-address .list-group-item", function () {
    $("#pills-address a.list-group-item")
        .find("input[type=checkbox]")
        .prop("checked", false);

    $(this).find("input[type=checkbox]").prop("checked", true);
});

$(document).on("click", "#pills-address a.list-group-item", function () {
    var user_a = $(this).find("input[type=checkbox]").val();
    $("input.user_address").val(user_a);
    if ($(this).hasClass("new-address")) {
        $(".pay-tab-three").addClass("disabled");
        $(".textarea-add-new-address").show();
        $("#selectMapDiv").show();
        $(".addresses-group").closest("div").hide();
    } else {
        $(".textarea-add-new-address").hide();
        $("#selectMapDiv").hide();
    }

    if ($(".main-addresses-group a.address").length) {
        $(".my-all-addresses").closest("div").removeClass("d-none");
        $(".my-all-addresses").prop("disabled", false);
    }
});

window.addressesList = function (data) {
    var htmlAddress = "";
    var htmlAddressFirst = "";

    htmlAddressFirst =
        '<a href ="javascript:void(0)"' +
        'class="list-group-item list-group-item-action new-address" id="customCheck0">' +
        '<div class="custom-control custom-checkbox">' +
        '<input type="checkbox"' +
        'class="custom-control-input"' +
        'name="new-address"' +
        'for="customCheck0">' +
        '<label class="custom-control-label"> <i class=' +
        '"fas fa-plus-circle"> </i> ' +
        "Add New Address </label> </div> </a>";

    htmlAddress += htmlAddressFirst;
    $.each(data[1], function (kk, vv) {
        var aDefault = vv.default == 1 ? "checked" : " ";
        var defaultDeleteAddress =
            aDefault != "checked"
                ? '<a href="javascript:void(0);"' +
                  'class="badge badge-pill badge-danger delete-address"' +
                  'data-val="' +
                  vv.id +
                  '" data-longAddr="' +
                  vv.address +
                  '"><i class="fas fa-trash"></i> ' +
                  "Delete</a>"
                : " ";

        htmlAddress +=
            '<div class="row">' +
            '<div class="col-sm-11 col-md-11">' +
            '<a href="javascript:void(0);"' +
            'class="list-group-item list-group-item-action d-flex align-items-center address"' +
            'for="customCheck">' +
            '<div class="custom-control custom-checkbox">' +
            '<input type="checkbox" class="custom-control-input r_data"' +
            'name="address" value="' +
            vv.id +
            '"' +
            'id="customCheck' +
            vv.id +
            '" ' +
            aDefault +
            ">" +
            "<label " +
            'class="custom-control-label">' +
            vv.address_title +
            " -" +
            "" +
            vv.address +
            "</label>" +
            "</div>" +
            "</a>" +
            "</div>" +
            '<div class="col-sm-1 col-md-1 d-flex align-items-center mt-2 mb-2">' +
            defaultDeleteAddress +
            "</div>" +
            "</div>";

        if (vv.default == 1) {
            htmlAddress +=
                '<input type="hidden" name="user_address" value="' +
                vv.id +
                '" class="user_address r_data">';
        }
    });
    clearAddressComponents();
    clearAddressData();

    $(".textarea-add-new-address").find("button").prop("disabled", true);
    $(".textarea-add-new-address").hide();

    $(".main-addresses-group").removeClass("d-none");
    $(".addresses-group").show();
    $(".addresses-group").html(htmlAddress);
};

$(document).on("click", ".my-all-addresses", () => {
    $("#selectMapDiv").hide();
    $(".main-addresses-group").show();
    $(".main-addresses-group .addresses-group").show();
});

$(document).on("click", ".delete-address", function () {
    let data = $(this).data("val");
    let dataAddress = $(this).data("longaddr");
    changeStatusAddress({
        route: "/address/delete/",
        buttonText: "Yes, delete this address!",
        val: data,
        address: dataAddress,
    });
});

$(document).on("click", ".new-address", function () {
    $(".default-address-button").hide();
});

$(document).on("click", ".my-all-addresses", function () {
    $(".default-address-button").show();
});

$(document).on("click", ".default-address-button", function () {
    changeStatusAddress({
        route: "/address/default/",
        buttonText: "Yes, set default this address!",
        val: $("input[name=address]:checked").val(),
        address: $("input[name=address]:checked")
            .closest("div")
            .find("label")
            .html(),
    });
});

window.clearAddressComponents = function () {
    for (const component in componentForm) {
        if (document.getElementById(component)) {
            document.getElementById(component).value = "";
        }
    }
};

window.clearAddressData = function () {
    $("#pac-input").val("");
    $("input[name=address_id]").val("");
    $("input[name=latLng]").val("");
    unBlockEl(".centerMarkerText");
};

window.changeStatusAddress = function (data = null) {
    Swal.fire({
        title: "Are you sure?",
        text: data.address,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: data.buttonText,
        showCancelButton: true,
        showLoaderOnConfirm: true,
        preConfirm: () => {
            return fetch(window.location.origin + data.route + data.val)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                })
                .catch((error) => {
                    Swal.showValidationMessage("Request failed: " + error);
                });
        },
        allowOutsideClick: () => !Swal.isLoading(),
    }).then((result) => {
        if (result.isConfirmed) {
            addressesList(result.value);
            checkAddressCount();
        }
    });
};
